import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import SectionHeading from "@/components/home/SectionHeading";
import ScreenThumb from "@/components/gallery/ScreenThumb";
import { useLightbox } from "@/components/gallery/useLightbox";
import { IonIcon } from "@/components/icons/AppIcon";
import { fadeUp } from "@/components/home/motion";
import { ALL_SCREENS, FEATURED_SCREENS } from "@/lib/screens";

export default function ScreensSection() {
  const { open, viewer } = useLightbox(FEATURED_SCREENS);
  return (
    <section id="screenshots" data-testid="screens-section" className="border-t border-[#2C2E29] py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <SectionHeading eyebrow="Schermen" title="Zo ziet Waidbook eruit.">
          Voorbeeldschermen uit de app met geanonimiseerde gegevens. Tik op een scherm om het volledig te bekijken.
        </SectionHeading>
        <div className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 lg:grid-cols-6">
          {FEATURED_SCREENS.map((s, i) => (
            <motion.div key={s.n} variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.2 }} custom={i}>
              <ScreenThumb screen={s} testid={`featured-screen-${s.n}`} onOpen={() => open(i)} />
            </motion.div>
          ))}
        </div>
        <div className="mt-12">
          <Link
            to="/schermen"
            data-testid="all-screens-link"
            className="inline-flex items-center gap-2 rounded-xl border border-[#2C2E29] bg-[#1C1D1A] px-5 py-3 text-sm font-semibold text-[#EAEBE7] transition-colors hover:border-[#CAA362]/50 hover:text-[#E0BE82]"
          >
            Alle {ALL_SCREENS.length} schermen bekijken
            <IonIcon name="chevron-forward" size={16} />
          </Link>
        </div>
      </div>
      {viewer}
    </section>
  );
}
